import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { BusinessPartnerContext } from '@/hooks/api/models';

/**
 * 2270. 法人番号から法人名検索
 * [GET] /workspaces/:identifier/business_partners/find_houjin_name
 */
type Props = {
  identifier: string;
  corporate_number: string;
  enabled?: boolean;
};

type FindCorporateNameResponse = {
  name: string;
  business_partner_context: BusinessPartnerContext;
};

const findCorporateName = (props: Props): Promise<FindCorporateNameResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/business_partners/find_houjin_name`, { params: props });
};

export const useFindCorporateName = (props: Props) => {
  return useQuery({
    queryKey: [{ ...props }],
    queryFn: () => findCorporateName(props),
    enabled: props.enabled,
  });
};
